import { render } from "./business-right-intro.vue?vue&type=template&id=45483d6a&ts=true"
import script from "./business-right-intro.vue?vue&type=script&lang=ts"
export * from "./business-right-intro.vue?vue&type=script&lang=ts"

import "./business-right-intro.vue?vue&type=style&index=0&id=45483d6a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__